import lombard from "redux/reducers/lombard";
import { createSelector } from "reselect";
import { CompletedTransStatusList } from "routes/LombardLoan/misc/const";

export const LomBardSelector = {
  state: (state) => state[lombard.name],
  loading: (state) => LomBardSelector.state(state).loading,
  getPortInfo: (state) => LomBardSelector.state(state).portInfo,
  notYetRegistered: (state) => LomBardSelector.state(state).notYetRegistered,
  filterTransactionDate: (state) => LomBardSelector.state(state).filterTransactionDate,
  numberOfPendingTrans: (state) => LomBardSelector.state(state).numberOfPendingTrans,
  getTransactions: createSelector([(state) => LomBardSelector.state(state).transactions], (transactions) => {
    const trans = {
      pendingTrans: [],
      completedTrans: [],
    };

    if (!transactions) return trans;

    return transactions.reduce((trans, tranaction) => {
      if (CompletedTransStatusList.includes(tranaction.transactionStatus)) {
        trans.completedTrans.push(tranaction);
      } else {
        trans.pendingTrans.push(tranaction);
      }

      return trans;
    }, trans);
  }),
};
